// extracted by mini-css-extract-plugin
module.exports = {"withBorder":"TwoByTwoGrid_withBorder__oYssK"};